<template>
  <fccTable
    striped
    hover
    :fields="fieldsBotoes"
    :orderby="sortBy"
    :actions="actions"
    :optionsButton="optionSolicitacoes"
    :items="lstBotoes"
    responsive
    :porPage="itemPorPage"
    :titlePage="titlePage"
    :titlePDF="titlePage"
  />
</template>

<script>
export default {
  data() {
    return {
      botaoFinal: {
        id: 0,
        dtfinal: null,
        dtinicio: null
      },
      itemPorPage: 50,
      sortBy: 'texto',
      titlePage: 'Cadastro de botões'
    }
  },
  methods: {
    listarTodosBotoes() {
      this.$emit('listarTodosBotoes')
    },
    deleteBotao(_, item) {
      this.$emit('deleteBotao', item)
    },
    editBotao(_, item) {
      this.$emit('editBotao', item)
    },
    addField() {
      this.$emit('addField')
    }
  },
  props: {
    fieldsBotoes: {
      type: Array,
      default: () => []
    },
    lstBotoes: {
      type: Array,
      default: () => []
    },
    optionSolicitacoes: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    }
  }
}
</script>